module.exports = __webpack_public_path__ + "static/media/groups.0630ea84.svg";